import { render, staticRenderFns } from "./message-index.vue?vue&type=template&id=532a6ab8"
import script from "./message-index.vue?vue&type=script&lang=js"
export * from "./message-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports